import { RequestsInstance } from 'api';
import { AxiosRequestConfig } from 'axios';
import { currentLanguage } from 'shared/constants/common';
import { BannerResponse, IPromotionDetais, RegistrationBannersResponse, RegistrationBannerType, SubBannerResponse } from 'shared/types/cms';
import { getUserDetails } from 'shared/util/utility';

const CMSApiWrapper = (requests: RequestsInstance) => {
	return {
		getContent: (moduleName: string) => {
			const config: AxiosRequestConfig = {
				params: {
					cmsContents: moduleName,
				},
			};
			return requests.get(`/cms/cms-content`, config);
		},
		getTranslation: (language: string) => {
			const params = { 'request-language': language };
			const config: AxiosRequestConfig = {
				params: params,
			};
			return requests.get(`/cms/app-translation`, config);
		},

		getEventDataById: (gameId: string) => {
			return requests.get(`/market/events/games/${gameId}`);
		},

		getHotBannerData: () => {
			return requests.get<BannerResponse>(`cms/hot`);
		},

		getBannerData: (forNonLogged: boolean) => {
			const config: AxiosRequestConfig = {
				params: {
					forNonLogged: forNonLogged,
				},
			};
			return requests.get<SubBannerResponse>(`cms/sub-banners`, config);
		},

		getRegistrationBanners: async () => {
			const response = await requests.get<RegistrationBannersResponse>(`cms/registration/banners`);
			const newBanners: Record<RegistrationBannerType, string | undefined> = {
				DESKTOP: undefined,
				MOBILE: undefined,
				SMALL_MOBILE: undefined,
				DESKTOP_V2: undefined,
				MOBILE_HEADER_V2: undefined,
				MOBILE_BACKGROUND_V2: undefined,
				VERIFICATION_DESKTOP: undefined,
				VERIFICATION_MOBILE_BACKGROUND: undefined,
			};
			for (const banner of response.data.data.banners) {
				newBanners[banner.type] = banner.url;
			}
			return newBanners;
		},

		getPlacementData: (screen: string) => {
			const config: AxiosRequestConfig = {
				params: {
					screen,
				},
			};

			return requests.get(`cms/placements`, config);
		},

		getEntertainmentData: (category?: string, limit?: number, pageNo?: number) => {
			const query: any = {};
			if (category) query.category = category;
			if (limit) query.limit = limit;
			if (pageNo !== null || pageNo !== undefined) query.pageNo = pageNo;

			const config: AxiosRequestConfig = {
				params: query,
			};

			return requests.get(`cms/entertainments`, config);
		},

		getPromotionsData: () => {
			return requests.get(`cms/promotions`);
		},

		getPromotionDetails: (promotionId: string) => {
			return requests.get<IPromotionDetais>(`cms/promotions/${promotionId}`);
		},
		getRegistrationPromotionsData: (code?: string) => {
			return requests.get(`cms/registration-promotions`, { params: { code } });
		},
		getPromotionSignUp: (promotionId: string) => {
			return requests.get(`cms/promotions/signup/${promotionId}`);
		},

		getCustomPageDetails: (id: string) => {
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': currentLanguage,
				},
			};
			return requests.get(`cms/custom-page/${id}`, config);
		},

		getRegulationData: (types: string[]) => {
			const config: AxiosRequestConfig = {
				params: {
					types,
				},
			};
			return requests.get(`cms/regulations`, config);
		},
		getMessages: (query: { limit: number; pageNo: number; current: boolean }) => {
			const config: AxiosRequestConfig = {
				params: {
					...query,
					userId: getUserDetails().userId,
				},
			};
			return requests.get(`cms/messages`, config);
		},
		getMessageDetail: (id: number) => {
			return requests.get(`cms/messages/${id}`);
		},
		deleteMessages: (ids: number[]) => {
			return requests.delete(`cms/messages/${ids}`);
		},
		deleteAllMessages: () => {
			return requests.delete(`cms/messages`);
		},
		readMessage: (id: number) => {
			const config: AxiosRequestConfig = {
				params: {
					userId: getUserDetails().userId,
				},
			};
			return requests.put(`cms/messages/${id}/read`, {}, config);
		},
		getUnreadMessageCount: () => {
			const config: AxiosRequestConfig = {
				params: {
					userId: getUserDetails().userId,
				},
			};
			return requests.get(`cms/messages/unread`, config);
		},
		getSportEventImage: () => {
			return requests.get(`cms/sport-event-image`);
		},
		getRetailShops: () => {
			return requests.get<BannerResponse>(`cms/bet-stores`);
		},
		getSeoDescriptions: (type: string) => {
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': currentLanguage,
				},
			};
			return requests.get(`cms/seo/${type}`, config);
		},
	};
};

export default CMSApiWrapper;
